export default class SelectedModel {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.selected-model');
        this.image = this.el.querySelector('.model-image img');
        this.name = this.el.querySelector('.model-name');
        this.param = this.router.data.param;
        this.items = this.router.data.items;
    }

    show() {
        const value = this.router.params.get(this.param);
        const item = value ? [...this.items].find((item) => item.dataset.selectValue == value) : null;
        if (item) {
            this.image.src = item.querySelector('.image').src;
            this.image.alt = item.querySelector('.text').innerHTML;
            this.name.innerHTML = item.querySelector('.text').innerHTML;
        } else {
            this.invalid();
        }
    }

    invalid() {
        this.router.update('search');
    }
}
